import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { EntityRelationDirection } from '@app/core/services/http-services/model/entity.service';
import { EnumToObject } from '@app/shared/helpers/transform-enum-to-object.helper';
import { IEnumKeyValue } from '@app/core/models/enumKeyValue.model';
import { _, TranslatePipe } from '@ngx-translate/core';
import { SVGIcon } from '@progress/kendo-angular-icons';
import { minusIcon, plusIcon } from '@progress/kendo-svg-icons';
import { ButtonGroupComponent, ButtonComponent } from '@progress/kendo-angular-buttons';

_('App.Direction');
_('Operative.Produce');
_('Operative.Consume');

@Component({
  selector: 'app-select-entity-relation-direction',
  template: `
    <kendo-buttongroup
      selection="single"
      size="large"
    >
      <button
        kendoButton
        type="button"
        [selected]="isProduce"
        themeColor="primary"
        (click)="onChangedVal(0)"
        [title]="'Operative.Produce' | translate"
      >
        {{ 'Abbreviations.Produce' | translate }}
      </button>
      <button
        kendoButton
        type="button"
        themeColor="primary"
        [selected]="isConsume"
        (click)="onChangedVal(1)"
        [title]="'Operative.Consume' | translate"
      >
        {{ 'Abbreviations.Consume' | translate }}
      </button>
    </kendo-buttongroup>
  `,
  styleUrls: ['./select-entity-relation-direction.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SelectEntityRelationDirectionComponent,
    },
    EnumToObject,
  ],
  imports: [ButtonGroupComponent, ButtonComponent, TranslatePipe],
})
export class SelectEntityRelationDirectionComponent implements OnInit, ControlValueAccessor {
  relationDirection: IEnumKeyValue[];
  selectedDirectionValue: number = null;
  isProduce = false;
  isConsume = false;

  //Icons
  plusIcon: SVGIcon = plusIcon;
  minusIcon: SVGIcon = minusIcon;

  @Output() onSelectDirection: EventEmitter<IEnumKeyValue> = new EventEmitter<IEnumKeyValue>();

  @Input() label: string = 'App.Direction';

  private onTouched!: Function;
  private onChanged!: Function;

  constructor(private readonly enumToObject: EnumToObject) {}

  ngOnInit(): void {
    this.relationDirection = this.enumToObject.transform(EntityRelationDirection);
  }

  onChangedVal(directionValue: number) {
    this.onTouched();
    this.setConsumeAndProduce(directionValue);

    if (directionValue == this.selectedDirectionValue) return;

    if (directionValue != null) {
      const e = this.relationDirection.find(d => d.value === directionValue);
      this.selectedDirectionValue = directionValue;
      this.onSelectDirection.emit(e);
    } else {
      this.selectedDirectionValue = null;
      this.onSelectDirection.emit(null);
    }

    this.onChanged(this.selectedDirectionValue);
  }

  writeValue(value: number): void {
    this.setConsumeAndProduce(value);
    this.selectedDirectionValue = value;
  }

  registerOnChange(onChange: any): void {
    this.onChanged = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  private setConsumeAndProduce(value: number) {
    this.isConsume = value === 1;
    this.isProduce = value === 0;
  }
}
